import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';
import { createRoot } from 'react-dom/client';
import './styles/global.css';
import { SENTRY_DNS } from './config';
import App from './routes';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import '@fontsource/open-sans';

if (SENTRY_DNS && !SENTRY_DNS.includes('example')) {
  Sentry.init({
    dsn: SENTRY_DNS,
    integrations: [new BrowserTracing()],
    tracesSampleRate: 1.0,
  });
}

const container = document.getElementById('root');

const root = createRoot(container as Element | DocumentFragment);
root.render(<App />);

// Register service worker for PWA support (production only).
serviceWorkerRegistration.register();
